import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import testImag from '../AssetDetailContent/test.png';

// import demoFile from './demo.pdf';
import { useEffect, useState } from 'react';
import { assetEditService } from 'api/assetEditService';
import Loading from 'components/Placeholders/Loading';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

const PdfPreview = ({path}) => {
  const [pdfFile, setPdfFile] = useState(null);
  const dispatch = useDispatch();
  

  useEffect(() => {
    const fetchPresignedUrl = async () => {
      try {
        dispatch({ type: 'LOADING SUCCESS', payload: true });
        const response = await assetEditService.getPresignedUrl(path); // Use the path prop to get the presigned URL
        dispatch({ type: 'LOADING SUCCESS', payload: false });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log('Presigned URL response:', data.success.preSignedURL);
        setPdfFile(data.success.preSignedURL); // Assuming the presigned URL is in the 'presignedUrl' field of the response
        // Use the presigned URL to fetch the PDF file
      } catch (error) {
        console.error('Error fetching presigned URL:', error);
      }
    };

    //presigned URL for the PDF file
    // api call to get the PDF file
    fetchPresignedUrl();
  }, []); // Add dependency array to prevent unnecessary re-renders

  useEffect(() => {
    const toolbarElement = document.querySelector('[aria-label="Attachment"]');
    if (toolbarElement) {
      // Remove the toolbar element
      toolbarElement.style.display = 'none';
    }
    const bookmarkElement = document.querySelector('[aria-label="Bookmark"]');
    if (bookmarkElement) {
      // Remove the bookmark element
      bookmarkElement.style.display = 'none';
    }
    const openFileElement = document.querySelector('[aria-label="Open file"]');
    if (openFileElement) {
      // Remove the open file element
      openFileElement.style.display = 'none';
    }
  });

  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  console.log('pdfFile', pdfFile);
  const isPdfFile = path && (path.toLowerCase().includes('.pdf'));

  return !pdfFile ? (
    <Loading />
  ) : (
    <>
      {!isPdfFile ? (
        <>
          <img src={pdfFile} alt="Preview" width="100%"/>
        </>
      ) : (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.js">
          <div style={{ height: '100%' }}>
            <Viewer fileUrl={pdfFile} plugins={[defaultLayoutPluginInstance]} />
            {/* <Viewer fileUrl={testImag} plugins={[defaultLayoutPluginInstance]} /> */}
          </div>
        </Worker>
      )}
    </>
  );
};


PdfPreview.propTypes = {
  path: PropTypes.string.isRequired,
};

export default PdfPreview;
